export const DISPATCH_AGENCY_ID = "DISPATCH_AGENCY_ID";

export const GET_ROUTES_DETAILS = "GET_ROUTES_DETAILS";

export const GET_BUSES_IDS = "GET_BUSES_IDS";

export const GET_BUSES = "GET_BUSES";

export const GET_ACTIVE_BLOCKS = "GET_ACTIVE_BLOCKS";

export const GET_VEHICLE_SIRI_DATA = "GET_VEHICLE_SIRI_DATA";

export const GET_BLOCKS_IDS = "GET_BLOCKS_IDS";

export const SET_ACTIVE_BUS = "SET_ACTIVE_BUS";

export const FETCH_DATA_ACTIVE_BUS = "FETCH_DATA_ACTIVE_BUS";

export const RESET_DATA_ACTIVE_BUS = "RESET_DATA_ACTIVE_BUS";

export const FETCH_LINE_SHAPE_STOPS = "FETCH_LINE_SHAPE_STOPS";

export const SET_DIRECTION = "SET DIRECTION";

export const SHOW_STOPS = "SHOW_STOPS";

export const DISPATCH_MAP_VIEW = "DISPATCH_MAP_VIEW";

export const HISTORICAL_POSITIONS = "HISTORICAL_POSITIONS";

export const SET_ROUTE_STOPS_BOTH = "SET_ROUTE_STOPS_BOTH";

export const BUS_ID_LINE_NUMBER = "BUS_ID_LINE_NUMBER";

export const POSITION_TIME = "POSITION_TIME";

export const GET_ROUTES_LIST = "GET_ROUTES_LIST";

export const SET_LOADING_TABLE = "SET_LOADING_TABLE";

export const SHOW_ROUTES_TABLE = "SHOW_ROUTES_TABLE";

export const FETCH_ACTIVE_ASSIGNMENTS_TO_BLOCKS = "FETCH_ACTIVE_ASSIGNMENTS_TO_BLOCKS";

export const DEVIATION_REPORT = "DEVIATION_REPORT";

export const DEVIATION_REPORT_MAP = "DEVIATION_REPORT_MAP";

export const SET_ROUTE_MAP_RANGE = "SET_ROUTE_MAP_RANGE";

export const TRIP_RAPORT_DATA = "TRIP_RAPORT_DATA";

export const REVERSE_GEOCODING_DONE = "REVERSE_GEOCODING_DONE";

export const GET_LAST_24_HOURS_DATA = "GET_LAST_24_HOURS_DATA";

export const SET_RANDOM_COLORS = "SET_RANDOM_COLORS";

export const DISPATCH_VEHICLE_ID = "DISPATCH_VEHICLE_ID";

export const DISPATCH_CURRENT_ZOOM = "DISPATCH_CURRENT_ZOOM";

export const GET_CURRENT_SERVICE_ID = "GET_CURRENT_SERVICE_ID";

export const GET_CURRENT_CALENDAR_BLOCKS_IDS = "GET_CURRENT_CALENDAR_BLOCKS_IDS";

export const GET_DOWNLOADABLE_TA_CONTENT = "GET_DOWNLOADABLE_TA_CONTENT";

//* New Action Types
export const GET_CREDENTIALS = "GET_CREDENTIALS";

export const GET_SCHEDULE_DETAILS = "GET_SCHEDULE_DETAILS";

export const GET_ALL_CALENDARS = "GET_ALL_CALENDARS";

export const DISPATCH_CURRENT_SHIFTS = "DISPATCH_CURRENT_SHIFTS";

export const DISPATCH_MAP_SETTINGS = "DISPATCH_MAP_SETTINGS";

export const DISPATCH_PROGRESS_BAR_DATA = "DISPATCH_PROGRESS_BAR_DATA";

export const DISPATCH_BLOCK_STATISTICS = "DISPATCH_BLOCK_STATISTICS";

//* New Action Types_2
export const GET_TRIP_DATA = "GET_TRIP_DATA";

export const RESET_TRIP_DATA = "RESET_TRIP_DATA";

export const GET_GTFS_RT_TRIP_UPDATES = "GET_GTFS_RT_TRIP_UPDATES";

export const IS_MAP_READY = "IS_MAP_READY";

export const SET_BLACK_ROUTES = "SET_BLACK_ROUTES";

export const BUS_LOCATIONS_BY_DATE = "BUS_LOCATIONS_BY_DATE";

export const RESET_BUS_LOCATIONS_BY_DATE = "RESET_BUS_LOCATIONS_BY_DATE";

export const DISPATCH_SELECTED_ROUTES_STOPS = "DISPATCH_SELECTED_ROUTES_STOPS";

//* Alerts
export const GET_AGENCY_ALERTS = "GET_AGENCY_ALERTS";

//* Chart Profile
export const PROFILE_DATA = "PROFILE_DATA";

//* Swiftly
export const FILTER_BUSES_BY_TIME_DEVIATION = "FILTER_BUSES_BY_TIME_DEVIATION";

export const DISPATCH_AVERAGE_SPEED_DATA = "DISPATCH_AVERAGE_SPEED_DATA";

export const DISPATCH_AVERAGE_SPEED_POLYLINE = "DISPATCH_AVERAGE_SPEED_POLYLINE";

export const FILTER_BUSES_BY_HEADWAY_DEVIATION_CATEGORY = "FILTER_BUSES_BY_HEADWAY_DEVIATION_CATEGORY";

export const FILTER_BUSES_BY_ROUTE_ID = "FILTER_BUSES_BY_ROUTE_ID";

//* New Action Types_3
export const START_WITH_ACCORDION = "START_WITH_ACCORDION";

export const DISPATCH_EARLY_LATE_SETTINGS = "DISPATCH_EARLY_LATE_SETTINGS";

export const DISPATCH_BLOCK_TRIP_DATA = "DISPATCH_BLOCK_TRIP_DATA";

export const DISPATCH_AVG_TRIP_DATA = "DISPATCH_AVG_TRIP_DATA";

export const DISPATCH_ROUTES_TRIPS_DATA = "DISPATCH_ROUTES_TRIPS_DATA";

export const DISPATCH_TRIP_INFO_DATA = "DISPATCH_TRIP_INFO_DATA";
